/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { ThemeContext } from '.';

export const useTheme = () => {
  return React.useContext(ThemeContext);
};
